import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useUser } from '../../../hooks/useUser';
import { likePost, unlikePost } from '../../../redux/actions/postActions';
import { Box, Button } from '@mui/joy';
import ThumbUpRoundedIcon from '@mui/icons-material/ThumbUpRounded';

type Props = {
  postId: string;
  likes: Array<string>;
  refetch: () => void;
};

export default function Metadata(props: Props) {
  const { likes, refetch, postId } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const userQuery = useUser();

  if (!userQuery.isSuccess) {
    return null;
  }

  const user = userQuery.data;

  const handleLike = async () => {
    try {
      setLoading(true);
      await dispatch(likePost(postId, user._id));
      await refetch();
    } finally {
      setLoading(false);
    }
  };
  const handleUnlike = async () => {
    setLoading(true);
    try {
      await dispatch(unlikePost(postId, user._id));
      await refetch();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {!likes.includes(user?._id) ? (
        <Button
          onClick={handleLike}
          loading={loading}
          startDecorator={<ThumbUpRoundedIcon />}
        >
          <p>{`Like (${likes.length})`}</p>
        </Button>
      ) : (
        <Button
          loading={loading}
          onClick={handleUnlike}
          variant="soft"
          startDecorator={<ThumbUpRoundedIcon />}
        >
          <p>{`Liked (${likes.length})`}</p>
        </Button>
      )}
    </Box>
  );
}

const defaultProps: Props = {
  likes: [],
  postId: '',
  refetch: () => {},
};

Metadata.defaultProps = defaultProps;
